<template>
  <div class="modal" tabindex="-1" :id="id" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-ice">
        <div class="modal-header bg-cosmos p-3">
          <span>{{ headerText }}</span>
          <modal-close-button @confirmed="closeModal()" />
        </div>
        <div class="modal-body fs-14">
          <div class="row mb-3">
            <div class="col-12 mb-2">
              <span class="text-bold"> Wählen Sie die gewünschte Umfrage </span>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-10">
              <v-select
                v-model="umfrage"
                :options="questionaires"
                label="designation"
                :placeholder="$t('global.survey')"
                :reduce="(option) => option.id"
              >
                <span slot="no-options">{{ $t("global.nodatafound") }}</span>
              </v-select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row w-100">
            <div class="col-12 p-0 d-flex justify-content-between text-center">
              <button
                type="button"
                class="btn btn-danger mr-3"
                data-dismiss="modal"
                @click="onCancel"
              >
                <span class="font-khand font-weight-bold">{{
                  $t("global.cancel")
                }}</span>
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="massenmailErstellen()"
                :disabled="!umfrage"
              >
                <span class="font-khand font-weight-bold">{{ okText }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiErrorToAlert } from "@/utils/Errorhandler";
import Api from "@/api/Api";
import QuestionaireApi from "@/api/QuestionaireApi";

import { modal } from "@/mixins/Modal";
import filter from "@/mixins/Filter";

import ModalCloseButton from "@/components/global/ModalCloseButton";

export default {
  name: "UmfrageVersendenModal",
  components: {
    ModalCloseButton,
  },
  mixins: [modal, filter],
  props: {
    id: {
      type: String,
      default: "umfrage-versenden-modal",
    },
    ids: {
      type: Array,
    },
    headerText: {
      type: String,
      default: "Umfrage versenden",
    },
    okText: {
      type: String,
      default: "OK",
    },
    umfrage: {
      type: String,
    },
    vonAnmeldung: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      type: 0,
      language: "DE",
      questionaires: [],
    };
  },
  created() {
    QuestionaireApi.get("questionaire-select/").then((response) => {
      this.questionaires = response.data;
    });
  },
  computed: {},
  mounted() {},
  methods: {
    onCancel() {
      this.closeModal();
    },
    onOk() {
      this.closeModal();

      let json = {
        date: this.date,
        consultant: this.consultant,
      };
      this.$emit("ok", json);
    },
    massenmailErstellen() {
      if (this.ids.length > 0 && this.umfrage != null) {
        this.loading = true;
        let tempList = this.ids;

        let json = {
          empfaenger: tempList,
          isMassMail: true,
          inhalt: "",
          zeitpunkt: new Intl.DateTimeFormat("ch").format(new Date()),
          umfrage: this.umfrage,
        };

        Api.post("mail/", json, { params: {} })
          .then((response) => {
            this.$router.push({
              name: "mail",
              params: {
                id: response.data.id,
                anzeige: 0,
              },
            });
            this.closeModal();
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
          })
          .finally(() => {
            this.loading = false;
          });
      } else
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.nopersonsselected"),
        });
    },
  },
};
</script>
